import { useQueries } from "@tanstack/react-query"
import { apiGET } from "data/api/get"

/**
 * Returns any metric sources and definitions for projects.
 * e.g. https://api.tokenterminal.com/v3/internal/projects/:slug/chart-metadata
 * @example
 * const { data } = useMetricMetadataByProjectSlug(["aave", "uniswap"])
 */

export const useMetricMetadataByProjectSlug = (projectSlugs: string[]) => {
  const result = useQueries({
    queries: projectSlugs.map((projectSlug) => ({
      queryKey: ["metric-metadata-for-project", projectSlug],
      queryFn: async () => {
        const result = await apiGET(
          `/v3/internal/projects/${projectSlug}/chart-metadata` as `/v3/internal/projects/:slug/chart-metadata`
        )
        return result.data
      },
      staleTime: 1000 * 60 * 10,
    })),
  })

  return {
    data: result.reduce((acc, data, index) => {
      return {
        ...acc,
        [projectSlugs[index]]: data.data,
      }
    }, {}) as Record<
      string,
      {
        metric_definitions: {
          metric_id: string
          definition: string
        }[]
        metric_sources: {
          metric_id: string
          definition: string
        }[]
      }
    >,
    isLoading: result.some((r) => r.isLoading),
    isError: result.some((r) => r.isError),
  }
}
